const style = {
  spacedBetweenRow: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },

  imgPlaceHolder: {
    fontSize: 50,
    marginRight: 10,
    width: 40,
  },
  candidateInfo: {
    textAlign: 'left',
    fontWeight: 600,
    width: '100%',
  },
  buttonIcon: {
    cursor: 'pointer',
    margin: 5,
  },
  simpleRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  simpleColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  userListContainer: {
    marginTop: 10,
    height: '55vh',
    overflowY: 'scroll',
    width: '100%',
  },
  userListItem: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 5,
    borderBottom: '1px solid gray ',
  },
  centeredText: {
    width: '100%',
    textAlign: 'center',
  },
};

export default style;
